import { IButton, IButtonProps } from "../IButton";

import { Link } from "react-router-dom";
import React from "react";

interface ILinkTo {
  pathname: string;
  search?: string;
  hash?: string;
  state?: unknown;
}

export interface ILinkButton extends IButtonProps {
  children: React.ReactNode;
  to: ILinkTo;
}
export const LinkButton = ({
  children,
  to,
  isDisabled = false,
  ...rest
}: ILinkButton) => {
  return (
    <Link to={to} style={{ pointerEvents: `${isDisabled ? "none" : "auto"}` }}>
      <IButton isDisabled={isDisabled} {...rest}>
        {children}
      </IButton>
    </Link>
  );
};
